import React, { Component } from 'react';
import axios from 'axios';

import AspectRatio from '@mui/joy/AspectRatio';
import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { BACK } from "./constant";
class PhotoGallery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageIds: []
        };
    }

    componentDidMount() {
        axios.get(`${BACK}/api/photos`)
            .then(response => {
                this.setState({ imageIds: response.data });
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        const { imageIds } = this.state
        return (
            <div  >
                <div className='title' >Galerie Foto</div>
                <div className='isPhone'>(Swipe left to see more) </div>
                <br />
                <div style={{ position: 'relative' }}>
                    <Box className='media-photo'
                        sx={{
                            display: 'flex',
                            gap: 1,
                            py: 0,
                            overflow: 'auto',
                            scrollSnapType: 'x mandatory',
                            '& > *': {
                                scrollSnapAlign: 'center',
                            },
                            '::-webkit-scrollbar': { display: 'flex' },
                        }}
                    >
                        {imageIds.map((imageId) => (
                            <Card
                                orientation="horizontal"
                                key={`${imageId.id}`}
                                sx={{
                                    '--Card-padding': (theme) => theme.spacing(0),
                                }}
                            >
                                <AspectRatio objectFit="scale-down" sx={{ minWidth: 290 }}>
                                    <img
                                        src={`https://lh3.googleusercontent.com/d/${imageId.image}`}
                                        alt={`imageId.event_name_photo`}
                                    />
                                </AspectRatio>
                            </Card>
                        ))}
                    </Box>
                    <div className="isDesktop" style={{ position: 'center', top: 0, left: 0, right: 0, alignItems: 'center', justifyContent: 'space-around' }}>
                        <KeyboardArrowLeftIcon
                            onClick={() => {
                                const container = document.querySelector('.media-photo');
                                container.scrollBy({
                                    left: -container.offsetWidth,
                                    behavior: 'smooth',
                                });
                            }}
                            sx={{ fontSize: 40, alignSelf: 'center', color: 'white', cursor: 'pointer' }}
                        />
                        <div style={{ position: "center", color: "white", fontFamily: 'Norton' }} > To browse left/right use the arrows </div>
                        <KeyboardArrowRightIcon
                            onClick={() => {
                                const container = document.querySelector('.media-photo');
                                container.scrollBy({
                                    left: container.offsetWidth,
                                    behavior: 'smooth',
                                });
                            }}
                            sx={{ fontSize: 40, alignSelf: 'center', color: 'white', cursor: 'pointer' }}
                        />
                    </div>
                </div>

            </div>
        );
    }
}

export default PhotoGallery;

